import { Injectable } from '@angular/core';
import { getProjectModel, newProjectModel, ProjectListModel, ProjectCampaignModel, ProjectModel} from '../models/project.model';
import { newCampaignModel, CampaignModel, DashboardCampaigns } from '../models/campaign.model';
import { MainService } from './main.service';
import { map, Observable, tap } from 'rxjs';
import { UsersService } from './users.service';
import { environment } from 'src/environments/environment';
import jwt_decode from 'jwt-decode';

//import { CutoffService } from './cutoff.service';

@Injectable({
  providedIn: 'root'
})
export class ProjectsService {
  current_campaign_id: number = 0;
  current_campaign: any = new ProjectCampaignModel();
  current_project_id: number = 0;
  current_project: any = new ProjectModel();
  promos_file_data: any = [];

  constructor(
    private main: MainService,
    private usrService : UsersService,
   // private cutoffService : CutoffService
  ) { }
  areaName : string = '/projects'

  //reglas Medios 
  //1 - reglas
  //2 - prioridad 
  async checkIfSameThenReplace(id_proy: number) {
    return new Promise(async (resolve, reject) => {
      if(id_proy > 0 && id_proy!=this.current_project_id) {
        this.main.ShowLoading();
        if(id_proy) {
          this.getProject(id_proy).subscribe((x: any) => {
            this.main.HideLoading();
            this.current_project = x.data;
            if(this.current_campaign_id == 0 || this.current_campaign_id != this.current_project.id_proy_camp) {
              this.getCampaignProject(this.current_project.id_proy_camp).subscribe((x: any) => {
                this.main.HideLoading();
                this.current_campaign = x.data.find((e:any)=> e.id == this.current_project.id_proy_camp);
                resolve(true);
              },
              (err:any) => {
                console.log(err);
                this.main.HideLoading();
              });
            } 
            else {
              resolve(true);
            }
          },
          (err:any) => {
            console.log(err);
            reject(err);
            this.main.HideLoading();
          });
        }
      }
      else {
        resolve(this.current_project);
      }
    });
  }

  loadCampaign(id_camp: number) {
    this.getCampaignProject(id_camp).subscribe((x: any) => {
      this.main.HideLoading();
      this.current_campaign = x.data.find((e:any)=> e.id == id_camp);
    },
    (err:any) => {
      console.log(err);
      this.main.HideLoading();
    })
  }

  loadPromo(id_camp: number) {
    this.main.ShowLoading();
    this.getPromotionData(id_camp).subscribe((x: any) => {
      this.main.HideLoading();
       return x.data;
    },
    (err:any) => {
      console.log(err);
      this.main.HideLoading();
    })
  }

  getCampaignProjects(id_company : number){
    var get : getProjectModel =  new getProjectModel()
    get.active = 1;
    return this.main.getRequest(this.areaName + "/campaigns/show/" + id_company).pipe(
      map((x:any)=>{
              let objReturn = new ProjectListModel();
              if(x.message == 'Success'){
                  x.data.forEach((e:any) => {
                      let tmpdate = new Date(e.date);
                      tmpdate.setTime(tmpdate.getTime() + 6 * 60 * 60 * 1000);
                      let tmpYear = tmpdate.getFullYear();
                      if(tmpYear != tmpdate.getFullYear()){
                          if(!objReturn.pastyears[tmpYear]){
                              objReturn.pastyears[tmpYear] =  new Array<any>()
                          }
                          objReturn.pastyears[tmpYear].push(e);
                      }else{
                         if(e.status == 1) {
                             objReturn.progress.push(e)
                         } 
                         else {
                             objReturn.finished.push(e)
                         }  
                      }
                  });
              }
              return objReturn;
      }));
  }

  getCampaignProject(campid : number){
    return this.main.getRequest(this.areaName + "/campaigns/" + campid);
  }

  newCampaignProject(newProject : newProjectModel){
    return this.main.postRequest(newProject, this.areaName + "/campaigns/create");
  }

  editCampaignProject(newCampain : newProjectModel){
    return this.main.postRequest(newCampain, this.areaName + "/campaigns/edit");
  }

  silenceCampaignProject(id_proj : number, silenced : boolean){
    return this.main.postRequest({id_proj, silenced}, this.areaName + "/campaigns/edit");
  }

  deleteCampaignProject(campid : number){
    return this.main.postRequest({ id: campid }, this.areaName + "/campaigns/delete/");
  }

  getProjectConfig(id : any){
    return this.main.getRequest("/projects/projects/show/" + id);
  }

  getProjectsSlim(id_camp:any){
    return this.main.getRequest("/projects/projects/show-lite/" + id_camp);
  }

  saveProjectVobos(data : any){
    return this.main.postRequest(data,this.areaName + "/vobos/save");
  }

  newProject(newCampaign : newCampaignModel){
    return this.main.postRequest(newCampaign, this.areaName + "/projects/create");
  }

  getProjects(id_camp: number){
    return this.main.getRequest(this.areaName + "/projects/list/" + id_camp);
  }

  editProject(newCampain : newCampaignModel){
    return this.main.postRequest(newCampain, this.areaName + "/projects/edit");
  }

  deleteProject(camp_id : number){
    return this.main.postRequest({ id: camp_id }, this.areaName + "/projects/delete/");
  }

  getProject(id_proj : number){
    return this.main.getRequest(this.areaName + "/project/" + id_proj);
  }

  //inventario
  getMedios(id_proj: number){
    return this.main.getRequest(this.areaName + "/medios/" + id_proj);
  }

  createMedio(editMedio : any){
    return this.main.postRequest(editMedio, this.areaName + "/medios/create");
  }

  editMedios(editMedio : any){
    return this.main.postRequest(editMedio, this.areaName + "/medios/edit");
  }
  
  deleteMedios(camp_id : number){
    return this.main.postRequest({ id: camp_id }, this.areaName + "/medios/delete/");
  }

  getMedio(id_medio : number){
    return this.main.getRequest(this.areaName + "/medio/" + id_medio);
  }

  getPOPs(id_medio: number){
    return this.main.getRequest(this.areaName + "/elementos-pop/" + id_medio);
  }

  createPOPs(editPop : any){
    return this.main.postRequest(editPop, this.areaName + "/elementos-pop/create");
  }

  createPOPsMultiple(pops : any){
    return this.main.postRequest({pops}, this.areaName + "/elementos-pop/create-multiple");
  }

  editPOPs(editPop : any){
    return this.main.postRequest(editPop, this.areaName + "/elementos-pop/edit");
  }

  deletePOPs(pop_id : number){
    return this.main.postRequest({ id: pop_id }, this.areaName + "/elementos-pop/delete/");
  }

  getPOP(id_pop : number){
    return this.main.getRequest(this.areaName + "/elementos-pop/" + id_pop);
  }

  createPOPConfig(editPOPConf : any){
    return this.main.postRequest(editPOPConf, this.areaName + "/elementos-pop/config/create");
  }

  editPOPConfig(editPOPConf : any){
    return this.main.postRequest(editPOPConf, this.areaName + "/elementos-pop/config/edit");
  }

  deleteConfig(id_popconf : number){
    return this.main.postRequest({ id: id_popconf }, this.areaName + "/elementos-pop/config/delete/");
  }

  getPOPConfigs(pop_id: number){
    return this.main.getRequest(this.areaName + "/elementos-pop/config/" + pop_id);
  }

  cloneProjectMedio(id_projecto_origen : number, id_projecto_destino : number){
    return this.main.postRequest({id_proyecto_origen : id_projecto_origen, id_proyecto_destino : id_projecto_destino }, this.areaName + "/proyectos/clone");
  }

  cloneProjectConfig(id_projecto_origen : number, id_projecto_destino : number){
    return this.main.postRequest({id_proyecto_origen : id_projecto_origen, id_campana_proyecto_destino : id_projecto_destino }, this.areaName + "/proyectos/cloneconfig");
  } 

  setCutoffProyect(id_proyecto_campana : number, id_cutoff : number){
    return this.main.postRequest({id_proyecto_campana : id_proyecto_campana, id_cutoff : id_cutoff }, this.areaName + "/proyectos/setcutoff");
  }

  createFormulario(form : any){
    return this.main.postRequest(form, this.areaName + "/proyectos/createformulario");
  }

  getFormularios(){
    return this.main.getRequest(this.areaName + "/proyectos/getformularios/");
  }

  getActiveProjectList(){
    return this.main.getRequest(this.areaName + "/projects/activelist/");
  }

   getActiveProjectCampList(){
    return this.main.getRequest(this.areaName + "/projects/activeproy/");
  }

  getConfigData(id : number){ 
    return this.main.getRequest(this.areaName + "/projects/config/" + id);
  }

  //Diagramacion

  getdiagramFiles(data: any) {
    return this.main.postRequest(data, this.areaName + "/diagram/getfiles");
  }

  newProjectDiagram(ins_data : any){
    return this.main.postRequest(ins_data, this.areaName + "/diagram/");
  }
  
  editProjectDiagram(ins_data : any){
    return this.main.postRequest(ins_data, this.areaName + "/diagram/edit/");
  }

  editProjectDiagramSlim(ins_data : any){
    return this.main.postRequest(ins_data, this.areaName + "/diagram/slim-edit/");
  }


  deleteProjectDiagram(id_diagrama : number){
    return this.main.postRequest({ id: id_diagrama }, this.areaName + "/diagram/delete/");
  }
  
  getPromotionData(id_camp : number){
    return this.main.getRequest(this.areaName + "/promotions/data/" + id_camp);
  }

  getPromotionColumns(id_camp : number){
    return this.main.getRequest(this.areaName + "/promotions/columns/" + id_camp);
  }

  getPromotionDownload(id_camp : number){
    return this.main.getRequest(this.areaName + "/promotions/download/" + id_camp);
  }

  getPromotionFiles(id_proj : number){
    return this.main.getRequest(this.areaName + "/files/promotions/" + id_proj);
  }

  uploadPromotionFile(form : FormData){
    return this.main.postRequestFormData(form, this.areaName + "/files/promotions/");
  }

  getExtraSucFiles(id_proj : number){
    return this.main.getRequest(this.areaName + "/files/extra_stores/" + id_proj);
  }
  
  uploadExtraSucFile(form : FormData){
    return this.main.postRequestFormData(form, this.areaName + "/files/extra_stores/");
  }

  getExtraSucData(id_proj : number){
    return this.main.getRequest(this.areaName + "/data/extra_stores/" + id_proj);
  }

  getProjectsChangelog(id_project : number){
    return this.main.getRequest(this.areaName + "/changelog/" + id_project);
  }

  getPromoChangelog(id_file : number, id_solicitud : number){
    return this.main.getRequest(this.areaName + "/promotions/changelog/" + id_file + "/" + id_solicitud);
  }

  getDiagramChangelog(id_diagram : number){
    return this.main.getRequest(this.areaName + "/diagram/changelog/" + id_diagram);
  }

  newProjectsMessage(newMessage : any){
    return this.main.postRequest(newMessage, this.areaName + "/message/");
  }

  getProjectsCampaignsChangelog(id_project : number){
    return this.main.getRequest(this.areaName + "/projects/changelog/" + id_project);
  }

  newProjectsCampaignsMessage(newMessage : any){
    return this.main.postRequest(newMessage, this.areaName + "/projects/message/");
  }

  setProjectPhaseRespVobo(form : FormData){
    return this.main.postRequestFormData(form, this.areaName + "/diagram/setVobos/");
  }

  resetVoboByProvider(ins_data : any){
    return this.main.postRequest(ins_data, this.areaName + "/diagram/resetVobo/");
  }
  resetVobo(ins_data : any){
    return this.main.postRequest(ins_data, this.areaName + "/diagram/resetVoboArte/");
  }


  getProjectInvTotals(id : number, media = false){
    if(media){
      //usa id_proyecto 
       return this.main.getRequest(this.areaName + "/totalinventorymedia/" + id);
    }else{
      //usa id_campana_proyecto 
       return this.main.getRequest(this.areaName + "/totalinventory/" + id);
    }
   
  }
  
  getProjectDistribution(id_proyecto: number, selected_cutoff_id: number){
    return this.main.postRequest({id_proyecto, selected_cutoff_id },this.areaName + "/getdistribucion/");
  }

  getProjectRespVobos(id_diagrama: number, id_proy_vobo: number){
    return this.main.postRequest({id_diagrama, id_proy_vobo },this.areaName + "/getRespuestasVobo/");
  }

  //campaing phased related code
  setPhase(phase_id : number, camp_rol : number, status : number, id_campana_proyecto : number, commentary : string){
    return this.main.postRequest({ phase_id : phase_id, camp_rol : camp_rol, status :  status, id_campana_proyecto : id_campana_proyecto , commentary :  commentary}, this.areaName + "/campaign/setphase/");
  }


  uploadCampaignProjectFile(form : FormData){
    return this.main.postRequestFormData(form, this.areaName + "/files/campaign/");
  }

  uploadCampaignProjectFileMultiple(form : FormData){
    return this.main.postRequestFormData(form, this.areaName + "/files/multiple/campaign");
  }


  getProjectsCampaignsFileChangelog(id_camp_proy_archivo : number){
    return this.main.getRequest(this.areaName + "/projects/file/changelog/" + id_camp_proy_archivo);
  }

  newProjectsCampaignsFileMessage(newMessage : any){
    return this.main.postRequest(newMessage, this.areaName + "/projects/file/message/");
  }

  getProviders(){
    return this.main.getRequest(this.areaName + "/providers/show/");
  }

  setProvidersSurvLock(item : any){
    return this.main.postRequest(item, this.areaName + "/providers/lock/");
  }


  getProvidersFiles(id: any){
    return this.main.getFilefApiromUrl(this.areaName + "/download/provider_survey_response/"+ id);
  }

  getProvidersList(){
    return this.main.getRequest(this.areaName + "/providers/list/");
  }

  activeProvider(provi : any){
    return this.main.postRequest(provi, this.areaName + "/providers/active");
  }

  getProviderAdminView(provi: any){
    return this.main.getRequest(this.areaName + "/providers/admin/" + provi);
  }

  setProvider(provi : any){
    return this.main.postRequest(provi, this.areaName + "/providers/create");
  }

  editProvider(provi : any){
    return this.main.postRequest(provi, this.areaName + "/providers/edit");
  }

  setProviderMemberCanEdit(provi : any){
    return this.main.postRequest(provi, this.areaName + "/providers/members/setedit");
  }

  setProviderMemberNotify(provi : any){
    return this.main.postRequest(provi, this.areaName + "/providers/members/setnotify");
  }

  deleteProvider(provi : any){
    return this.main.getRequest(this.areaName + "/providers/delete/" + provi);
  }

  hasPermissions(key : string, buho : boolean|any, client : boolean|any):  boolean{
    return this.usrService.getUser().id_rol == environment.role_admin_id || (buho==null&&this.isBuhoUsr()) || (client==null&&this.isClientUsr()) || (((buho?this.isBuhoUsr():false) || (client?this.isClientUsr():false)) && (this.usrService.getUser().permissions.includes(key)));
  }

  uploadCampaignProviderFile(form : FormData){
    return this.main.postRequestFormData(form, this.areaName + "/files/provider/");
  }

  getProvidersSurveys(id_proy_dia : number ){
    return this.main.getRequest(this.areaName + "/providersurveys/" + id_proy_dia);
  }

  deleteProviderSurvey(id : number){
    return this.main.postRequest({ id }, this.areaName + "/providersurveys/delete/");
  }
  
  saveMember(member: any) {    
    return this.main.postRequest(member, this.areaName +  "/providers/members/create");
  }

  saveResponse(response: any) {    
    return this.main.postRequest(response, this.areaName +  "/providersurveys/response/save");
  }

  getProviderView(view: any) {    
    return this.main.getRequest(this.areaName + "/providersurveys/view/" + view);
  }

  uploadProviderResponseFile(form : FormData){
    return this.main.postRequestFormData(form, this.areaName + "/files/provider_survey_response");
  }

  reuploadCampaignProviderFile(form : FormData){
    return this.main.postRequestFormData(form, this.areaName + "/files/providerreload/");
  }

  resendProviverSurveyEmail(item : any){
    return this.main.postRequest(item, this.areaName +  "/providers/resend/");
  }

  getProviderMemberSignUpView(view: any) {    
    return this.main.getRequest(this.areaName + "/providersignup/view/" + view);
  }

  setProviderMemberPassword(newpass : any){
    return this.main.postRequest(newpass, this.areaName + "/providermember/setpassword/");
  }

  setProviderMemberActive(active : any){
    return this.main.postRequest(active, this.areaName + "/providers/members/active");
  }

  deleteProviderMember(id_provider_member : number){
    return this.main.postRequest({ id: id_provider_member }, this.areaName + "/members/delete/");
  }

  getListProjectsProvidersView() {    
    return this.main.getRequest(this.areaName + "/projects/member/show/");
  }

  getFormUrl(id_provider_survey : number){
    return this.main.postRequest({ id_provider_survey : id_provider_survey }, this.areaName + "/getformurl/");
  }

  isBuhoUsr(): boolean{
    return  this.usrService.getUser().id_rol == environment.role_buho ||  this.usrService.getUser().id_rol == environment.role_admin_id;
  }

  getProviverSurveyChangelog(prov_surv : number){
    return this.main.getRequest(this.areaName + "/providersurv/changelog/" + prov_surv);
  }

  getProviverSurveyPreview(prov_surv : number){
    return this.main.getRequest(this.areaName + "/providersurveys/preview/" + prov_surv);
  }

  getProviverMemberInfo(prov_member_id : number){
    return this.main.getRequest(this.areaName + "/providers/members/view/" + prov_member_id);
  }

  editMember(member: any) {    
    return this.main.postRequest(member, this.areaName +  "/providers/members/edit");
  } 

  newProviverSurveyMessage(newMessage : any){
      return this.main.postRequest(newMessage, this.areaName +  "/providersurv/message/");
  }

  //preproyectos
  newPreprojectForm(newPreproject : any){
    return this.main.postRequest(newPreproject, this.areaName +  "/preprojectform/create");
  }

  updatePreprojectForm(newPreproject : any){
    return this.main.postRequest(newPreproject, this.areaName +  "/preprojectform/edit");
  }

  getPreprojectCamp(id : number){
    return this.main.getRequest(this.areaName + "/preprojectform/" + id);
  }

  getPreprojectTotals(id : number){
    return this.main.getRequest(this.areaName + "/preprojecttotals/" + id);
  }
  
  uploadPreprojectTotalFile(form : FormData){
    return this.main.postRequestFormData(form, this.areaName + "/files/preprojectotals/");
  }

  uploadPreprojectFormFile(form : FormData){
    return this.main.postRequestFormData(form, this.areaName + "/files/preprojectform/");
  }

  uploadPreprojectPDFFile(form : FormData){
    return this.main.postRequestFormData(form, this.areaName + "/files/preprojectpdf/");
  }

  getPreprojectPdfs(id : number){
    return this.main.getRequest(this.areaName + "/preprojectpdfs/" + id);
  }

  deletePreprojectForm(id : number){
    return this.main.postRequest({ id }, this.areaName + "/preprojectform/delete/");
  }

  deletePreprojectPDF(id : number){
    return this.main.postRequest({ id }, this.areaName + "/preprojectpdfs/delete/");
  }

  generatePreproject1(preproject : any){
    return this.main.postDataUrlExt(preproject, "http://134.209.122.193:8001/preproyecto_auto_nest/" );
  }

  generatePreproject(preproject : any){
    return this.main.postRequest(preproject, this.areaName + "/preprojectform/generate" );
  }

  setFactura(factura : any){
    return this.main.postRequest(factura, this.areaName + "/providers/setfactura" );
  }

  isClientUsr(): boolean{
    return  this.usrService.getUser().id_rol == environment.role_client;
  }

  getTokenData(token : any){
    return jwt_decode(token);
  }

  setMediosStockConfig(editMedio : any){
    return this.main.postRequest(editMedio, this.areaName + "/medios/set_stock_config");
  }

  getFacturasProject(id : number){
    return this.main.getRequest(this.areaName + "/projects/facturas/" + id);
  }

  uploadProviderFacturaFile(form : FormData){
    return this.main.postRequestFormData(form, this.areaName + "/files/provider_factura");
  }

  getProvidersFacturaFiles(id: any){
    return this.main.getFilefApiromUrl(this.areaName + "/download/provider_factura/"+ id);
  }

  getFacturaPDF(id: any){
    return this.main.getFilefApiromUrl(this.areaName + "/download/facturas/"+ id);
  }

  selectMedio(id_proy : any, mediosSel : Array<any>){
    let mediosSelStr = JSON.stringify(mediosSel);
    return this.main.postRequest({id_campana_proyecto : id_proy, new_selected_medios : mediosSelStr }, this.areaName + "/projects/selectmedios");
  }

  selectAtributes(id_proy : any, attSel : Array<any>){
    let attSelStr = JSON.stringify(attSel);
    return this.main.postRequest({id_proyecto : id_proy, new_selected_attributes : attSelStr }, this.areaName + "/projects/selectattributes");
  }


  setColumnasPromociones(id_proy : any, colSel : Array<any>){
    let colSelStr = JSON.stringify(colSel);
    return this.main.postRequest({id_campana_proyecto : id_proy, new_selected_col : colSelStr }, this.areaName + "/projects/promocionesColumns");
  }

  getColumnsPromotionsByUser(id: any){
    return this.main.getRequest(this.areaName + "/projects/get_promociones_columns/"+ id);
  }

  setNewColumnasPromociones(id_proy : any, colSel : Array<any>){
    let colSelStr = JSON.stringify(colSel);
    return this.main.postRequest({id_campana_proyecto : id_proy, new_selected_col : colSelStr }, this.areaName + "/projects/savePromocionesColumns");
  }
  saveSheetPromociones(form : FormData){
    return this.main.postRequestFormData(form, this.areaName + "/files/sheet/promotions/");
  }

  editSheetPromociones(form : FormData){
    return this.main.postRequestFormData(form, this.areaName + "/files/edit/promotions/");
  }

  validateSheetPromociones(form : FormData){
    return this.main.postRequestFormData(form, this.areaName + "/files/sheet/validate/");
  }
  getImagesDiagramation(id: number, type: number){
    return this.main.getRequest(this.areaName + "/get_images_diagramation/" + id + "/" + type);
  }
  deleteImageDiagramation(id: number, type: number){
    return this.main.getRequest(this.areaName + "/delete_images_diagramation/" + id + "/" + type);
  }
  setImagesDiagramation(form : FormData){
    return this.main.postRequestFormData(form, this.areaName + "/images_diagramation/");
  }
  setPlantillaVobos(phases: Array<any>, nombre: string, id_proy: number){
    let phasesStr = JSON.stringify(phases);
    return this.main.postRequest({phases : phasesStr, nombre : nombre, id_proy: id_proy }, this.areaName + "/projects/savePlantillaVobos");  
  }
  getPlantillasVobos(id_proy: number){
    return this.main.getRequest(this.areaName + "/projects/get_plantillas_vobos/" + id_proy);
  }
  updatePlantillaVobos(id_plant: number, phases: Array<any>){
    let phasesStr = JSON.stringify(phases);
    return this.main.postRequest({id_plant : id_plant, phases : phasesStr }, this.areaName + "/projects/updatePlantillaVobos"); 
  }
  deletePlantillaVobos(id_plant: number){
    return this.main.postRequest({id_plant : id_plant }, this.areaName + "/projects/deletePlantillaVobos"); 
  }
  updateDiagramPromosMasive(diagramations: Array<any>){
    return this.main.postRequest({diagramations : diagramations }, this.areaName + "/projects/savePromosMasive"); 
  }
   getSucursalesById(suc_id : string){
    return this.main.postRequest( {ids: suc_id}, this.areaName + "/get_sucursales/");
  }
  
  getFileViewer(url : string){
    return this.main.postRequest({url: url}, this.areaName + "/files/viewer");
  }
  
  getFileViewerBlob(url: string): Observable<Blob> {
    return this.main.postRequest({ url: url }, this.areaName + "/files/viewer", { responseType: 'blob' });
  }
    
  getProviderViewerBlob(id: any): Observable<Blob> {
    return this.main.getRequest( this.areaName + "/providersurveys/file/viewer/"+ id, { responseType: 'blob' });
  }

  newDiagramMessage(newMessage : any){
    return this.main.postRequest(newMessage, this.areaName + "/diagram/message/");
  }

  createSolicitudes(payload : any){
    return this.main.postRequest(payload, this.areaName + "/promotions/create");
  }

  getUsersByPermiso(clave : any){
    return this.main.postRequest({clave}, this.areaName + "/get_users_permiso");
  }

  getSolicitudes(id_proyecto : any, id_archivo : any, by_user : any = false, status : any = null){
    return this.main.postRequest({id_proyecto, id_archivo, by_user, status}, this.areaName + "/promotions/solicitudes");
  }

  acceptSoliPromociones(form : FormData){
    return this.main.postRequestFormData(form, this.areaName + "/promotions/accept");
  }

  rejectSoliPromociones(payload : any){
    return this.main.postRequest(payload, this.areaName + "/promotions/reject");
  }

   getPromoChangelogByCamp(payload : any){
    return this.main.postRequest(payload, this.areaName +  "/promotions/changelog");
  }

  updatePromoConfig(id_file : number, config : any){
    return this.main.postRequest({id_file : id_file, config : config}, "/projects/promotion/config/update");
  }

  getDiagramaArchivosImages(data: any){
    return this.main.getRequest(this.areaName + "/get_diagrama_archivos_images/"+ data.id);
  }

  setReestablecerImagen(data: any){
    return this.main.postRequest(data, this.areaName + "/projects/reestablecer_imagen_art");
  }
  
   getMediosFull(id_proj: number){
    return this.main.getRequest(this.areaName + "/medios-full/" + id_proj);
  }

  uploadSharedDiagramFile(form : FormData){
    return this.main.postRequestFormData(form, this.areaName + "/files/shared/images");
  }
  
  getDiagramaArchivoSharedCampana(data: any){ //obtiene todos los artes del camaana 
    return this.main.postRequest(data, this.areaName + "/shared/get_campana_all");
  }

  getDiagramaArchivoSharedImages(data: any){ //obtiene todos los artes del diagrama
    return this.main.postRequest(data, this.areaName + "/shared/get_archivos_diagrama");
  }

   updateDiagramaArchivoShared(data: any){ //actualiza el shared_config y el aprobado
    return this.main.postRequest(data, this.areaName + "/shared/update");
  }
}

export class PreProyecto {
  id! : number;
  id_camp! : number;
  nombre_str!: string;
  cliente!: string;
  nombre!: string;
  folio!: string;
  proyecto!: string;
  contacto!: string;
  tipo!: string;
  area_responsable!: string;
  impresion!: string;
  color!: string;
  tipo_envio!: string;
  recepcion!: string;
  dia_inicio!: number;
  mes_inicio!: string;
  ano_inicio!: number;
  dia_fin!: number;
  mes_fin!: string;
  ano_fin!: number;
  excel_formulario!: string;
  excel_totales!: string;
  pdfs!: string[];
  created_at! : string;
}